import axios from "axios"
import { Link, navigate } from "gatsby"
import React, { memo } from "react"
import { useForm } from "react-hook-form"
import { parsePhoneNumber } from "react-phone-number-input"
import "react-phone-number-input/style.css"
import PhoneInputFormItem from "../../Common/new/input"
import useUserCountry from "../../hooks/useUserCountry"
import FormButtonRed from "../buttons/formButtonRed/formButtonRed"
import InputLabel from "../InputFields"
import * as style from "./WebinarForm.module.css"

const WebinarForm = ({
  CustomClass,
  homeData,
  elementRef,
  comingSoonWebinar,
  slug,
}) => {
  const { inquiryEmail, contactUsaNumber } = homeData?.myThemeOptionsSettings

  const defaultCountry = useUserCountry();

  const {
    register,
    handleSubmit,
    reset,
    control,
    setError,
    formState: { errors, isSubmitting },
  } = useForm()

  const onSubmit = async value => {
    const parsedPhoneNumber = parsePhoneNumber(value?.phone)
    if (parsedPhoneNumber?.country == "IN" && parsedPhoneNumber?.nationalNumber?.length !== 10) {
      setError("phone", {
        type: "manual",
        message: "Enter Valid Number!!",
      });
      return;
    }
    let formData = new FormData()
    formData.append("email", value?.email)
    formData.append("fullName", value?.fullName)
    formData.append("phone", value?.phone)
    formData.append("companyName", value?.companyName)
    formData.append("webinar_slug", slug)

    try {
      await axios({
        method: "post",
        url: `${process.env.GATSBY_API_URL}/wp-json/agile/v1/newwebinar/`,
        data: formData,
      })
      navigate("/webinar-thank-you")
      reset({
        email: "",
        phone: "",
        companyName: "",
        fullName: "",
      })
    } catch (error) {
      console.error("error: ", error)
    }
  }

  const emailRequired = errors.email && errors.email.type === "required"
  const emailPattern = errors.email && errors.email.type === "pattern"
  const fullnamePattern = errors.fullname && errors.fullname.type === "pattern"


  return (
    <>
      {comingSoonWebinar == "yes" && (
        <section
          className={`${style.business_form} ${CustomClass}`}
          ref={elementRef}
          id="hirescroll"
        >
          <div className="container">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className={style.business_form_wrap}>
                <div className={style.business_form_left}>
                  <div className={style.form_header}>
                    <h2>Save my seat</h2>
                    <p>Please provide below Information to book your seat.</p>
                  </div>
                  <ul className={style.business_form_listing}>
                    <li>
                      <div className={style.full_col}>
                        <div className={style.form_grp}>
                          <InputLabel
                            forTxt="fullname"
                            labelText="Full Name"
                          />
                          <input
                            type="text"
                            className={style.input_grp}
                            placeholder="Full Name"
                            {...register("fullName", {
                              required: true,
                              validate: fullName => {
                                if (!fullName?.trim()) {
                                  return "pattern"
                                }
                              },
                            })}
                          />
                          {errors?.fullName?.type === "required" && (
                            <span
                              style={{
                                color: "#e95444",
                                marginTop: "5px",
                                display: "inline-block",
                              }}
                            >
                              Full Name is Required!!{" "}
                            </span>
                          )}
                          {fullnamePattern && (
                            <span
                              style={{
                                color: "#e95444",
                                marginTop: "5px",
                                display: "inline-block",
                              }}
                            >
                              Please Enter Valid Name!!{" "}
                            </span>
                          )}
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={style.two_col}>
                        <div className={style.form_grp}>
                          <InputLabel forTxt="email" labelText="Email" />
                          <input
                            type="email"
                            className={style.input_grp}
                            placeholder="Email"
                            {...register("email", {
                              required: true,
                              pattern:
                                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                            })}
                          />
                          {emailRequired && (
                            <span
                              style={{
                                color: "#e95444",
                                marginTop: "5px",
                                display: "inline-block",
                              }}
                            >
                              Email is Required!!{" "}
                            </span>
                          )}
                          {emailPattern && (
                            <span
                              style={{
                                color: "#e95444",
                                marginTop: "5px",
                                display: "inline-block",
                              }}
                            >
                              Please Enter Valid Email{" "}
                            </span>
                          )}
                        </div>
                      </div>
                      <div className={style.two_col}>
                        <div className={style.form_grp}>
                          <InputLabel
                            forTxt="phone"
                            labelText="Phone Number"
                          />
                          <PhoneInputFormItem
                            name="phone"
                            control={control}
                            errors={errors}
                            defaultCountry={defaultCountry}
                            phoneRequired={true}
                            CustomClass={style.input_grp}
                            selectClassName={style.country_code_select}
                          />

                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={style.full_col}>
                        <div className={style.form_grp}>
                          <InputLabel
                            forTxt="companyName"
                            labelText="Company name"
                          />
                          <textarea
                            type="text"
                            className={style.input_grp}
                            placeholder="Company name"
                            {...register("companyName", {})}
                          ></textarea>
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className={style.submit_area}>
                        <div className={style.form_grp}>
                          <p>
                            By sending this form I confirm that I have read and
                            accept the{" "}
                            <Link href="/privacy-policy/">Privacy Policy</Link>
                          </p>
                          <div style={{ position: "relative" }}>
                            <FormButtonRed
                              btnText={isSubmitting ? "Loading. . ." : "Submit"}
                              customClass="btn-webinar m-0"
                            />
                            {/* {isSubmitting && (
                              <LoadingSpinner addClass="form-loading" />
                            )} */}
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <div className={style.business_form_right}>
                  <ul className={style.review_list}>
                    <li>
                      <span className={style.rightLabel}>Write to us</span>
                      <a href="mailTo:inquiry@agileinfoways.com">
                        {inquiryEmail}
                      </a>
                    </li>
                    <li>
                      <span className={style.rightLabel}>Call Us</span>
                      <a href={`tel:${contactUsaNumber}`}>{contactUsaNumber}</a>
                      <br />
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(WebinarForm)
